import { images } from "@img/imagesMap";

interface WeeklyOffTableHeaderProps {
  title: string;
  disabledColor?: boolean;
  nurseCount: number;
  showDayColumn?: boolean;
}

function WeeklyOffTableHeader({
  title,
  disabledColor,
  nurseCount,
  showDayColumn = false,
}: WeeklyOffTableHeaderProps) {
  return (
    <>
      <div
        className={`flex h-10 comp_tr--mgmt2 text-white font-bold text-center rounded-tl-[10px] rounded-tr-[10px] text-[15px] font-pretendard ${disabledColor ? "bg-[#C4C4C4]" : "bg-[#0259c6]"}`}
      >
        <div></div>
        <div className="flex justify-center items-center ml-5">
          <img
            src={images.icon_person}
            alt=""
            className="mr-[3px]"
            style={{ height: "1em" }}
          />
          <div className="flex justify-center items-center">{nurseCount}</div>
        </div>
        <div
          className={`${!showDayColumn && "!-ml-40"} col-start-3 col-end-[-1] flex justify-center items-center`}
        >
          {title}
        </div>
      </div>
      <div
        className={`bg-[#F0F0F2] comp_tr ${showDayColumn ? "comp_tr--mgmt2-with-day" : "comp_tr--mgmt2"} comp_tr--header`}
      >
        <div className="py-2 px-3"></div>
        <div className="py-2 px-3 whitespace-nowrap text-center text-[15px] font-pretendard font-bold">
          No.
        </div>
        <div className="py-2 px-3 whitespace-nowrap text-center text-[15px] font-pretendard font-bold">
          사번
        </div>

        <div className="py-2 px-3 whitespace-nowrap text-center text-[15px] font-pretendard font-bold">
          이름
        </div>
        <div className="py-2 px-3 whitespace-nowrap text-center text-[15px] font-pretendard font-bold">
          직종
        </div>
        <div className="py-2 px-3 whitespace-nowrap text-center text-[15px] font-pretendard font-bold">
          경력
        </div>
        <div className="py-2 px-3 whitespace-nowrap text-center text-[15px] font-pretendard font-bold">
          근무형태
        </div>
        <div className="py-2 px-3 whitespace-nowrap text-center text-[15px] font-pretendard font-bold">
          프리셉터 지정
        </div>
        <div className="py-2 px-3 whitespace-nowrap text-center text-[15px] font-pretendard font-bold">
          입사일
        </div>
        <div className="py-2 px-3 whitespace-nowrap text-center text-[15px] font-pretendard font-bold">
          근무 종료일
        </div>
        <div className="py-2 px-3 whitespace-nowrap text-center text-[15px] font-pretendard font-bold">
          메모
        </div>
        {/* '총 배치인원' 탭에서만 '요일' 컬럼 표시 */}
        {showDayColumn && (
          <div className="py-2 px-3 whitespace-nowrap text-center text-[15px] font-pretendard font-bold">
            요일
          </div>
        )}
      </div>
    </>
  );
}

export default WeeklyOffTableHeader;
